<template>
	<div class="action-button-wrapper">
      <b-button size="sm" class="site-action-btn" variant="link" target="_blank" :href="serverURL+'ajax.php?action=loadSite&siteID='+site.siteID+'&where=post-new'">
          <span class="icon-cont">
              <write-new-post style="opacity:0.74" class="icon-default"></write-new-post>
          </span>
          <span>Write new post</span>
      </b-button>
  </div>
</template>

<script>
import WriteNewPost from '../../assets/writepost.svg';
export default {
  name: "viewsite",
  props: ["site"],
  components:{
  	WriteNewPost
  },
  data() {
    return {
      serverURL: window.serverURL,
    };
  },
};
</script>